import EdgeMonitor from '../../../components/edge_monitor/EdgeMonitor.jsx';
import InlineComponent from './inlineComponent.jsx';

module.exports = class edgeMonitorInlineComponent extends InlineComponent {
  define() {
    this.component = EdgeMonitor;
  }
};
